import phoneNumber from "../constants/phone-number";

const { usPhone } = phoneNumber();

const usPhoneNumberFormatter = (input) => {
  if (input) {
    //check if the input is greater than 16 characters (format: (123) - 456 7890)
    if (input.length > usPhone.MAXIMUM_FORMATTED_PHONE_LENGTH) {
      input = input.substring(0, usPhone.MAXIMUM_FORMATTED_PHONE_LENGTH);
      return {
        original: input.replace(/[^\d]/g, ''),
        formatted: input,
      };
    }

    //remove all non-digit characters
    const originalNumber = input.replace(/[^\d]/g, '');
    let number = originalNumber;

    /*------------------ Country Code -----------------
    * check if the format is (123) -
    * if the last character was removed then,
    * reformat the number to (12
    -------------------------------------------------*/
    if (input.length === usPhone.UNFORMATTED_PHONE_AREA_CODE_LENGTH) {
      number = number.toString().slice(0, -1);
    }

    if (number.length < usPhone.MIN_EXCHANGE_CODE_LENGTH) {
      //checking if the number is properly formatted with the country code
      if (number.length > usPhone.EMPTY_LENGTH) {
        if (number.length > usPhone.EMPTY_LENGTH && number.length <= usPhone.UNFORMATTED_PHONE_COUNTRY_CODE_LENGTH) {
          number = `(${number}`;
        } else {
          number= `(${number}) -`;
        }
      }
    } else if (number.length < usPhone.MIN_SUBSCRIBER_NUMBER_LENGTH) {
        //this will format the number into (123) - 456
        number = number.replace(/(\d{3})(\d{0,3})/, "($1) - $2");
    } else {
      //this will format the number into (123) - 456 7890
        number = number.replace(/(\d{3})(\d{3})(\d{0,4})/, "($1) - $2 $3");
    }
    return {
      original: originalNumber,
      formatted: number,
    };
  } else {
    return {
      original: '',
      formatted: '',
    };
  }
}

export default usPhoneNumberFormatter;
